import React, { useState, useEffect, useRef, useCallback, useMemo, } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Card, Chip, IconButton, CardContent, Grid, Paper, Container, Tooltip as TooltipCustom, useMediaQuery, Backdrop, CircularProgress, useTheme, Stack } from '@mui/material';
import { Menu as MenuIcon, Help as HelpIcon } from '@mui/icons-material';
// app UI controller for toggling sidenav
import { useMaterialUIController, setMiniSidenav } from "context";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FilterPanelContainer from "components/Filter/Filterpopup"
import datadrilldown from "assets/images/selectedicons/DataDrillDown.svg";
import drillDownArrow from "assets/images/selectedicons/DrillDownArrow.svg";
import datadrillhover from 'assets/images/selectedicons/Data Drill Down1.svg'


import Banner1 from "../../../assets/images/Retailers/banner1.png"
import Banner_2 from "../../../assets/images/Retailers/banner 2.png"
import Banner_3 from "../../../assets/images/Retailers/Sams-Club-Logo.png"
import Banner2 from "../../../assets/images/Retailers/banner 3.png"
import Banner5 from "../../../assets/images/Retailers/retails55.png"
import Banner6 from "../../../assets/images/Retailers/banner6.png"
import Banner7 from "../../../assets/images/Retailers/banner7.png"
import Banner8 from "../../../assets/images/Retailers/retails88.png"
import Banner9 from "../../../assets/images/Retailers/retails99.png"
import Banner10 from "../../../assets/images/Retailers/banner10.png"
import Banner11 from "../../../assets/images/Retailers/retails11.png"
import Banner12 from "../../../assets/images/Retailers/retails12.png"
import Banner13 from "../../../assets/images/Retailers/banner13.png"
import Banner14 from "../../../assets/images/Retailers/retails14.png"
import Banner15 from "../../../assets/images/Retailers/retails15.png"

import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import SouthIcon from '@mui/icons-material/South';



const Retails = ({ subcategoryToken: propSubcategoryToken }) => {

    const naviagte = useNavigate();
    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav } = controller;
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Below 900px
    const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg')); // Between 900px and 1200px

    // State for API data

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);




    useEffect(() => {
        const header = document.querySelector('.MuiAppBar-root');
        if (header) {
            header.style.display = 'none';
        }
    }, []);



    // Toggle sidenav from the page menu icon
    const isTogglingSidenavRef = useRef(false);
    const handleToggleSidenav = useCallback(() => {
        if (isTogglingSidenavRef.current) return;
        isTogglingSidenavRef.current = true;
        // Defer to next frame to avoid blocking heavy charts paint
        requestAnimationFrame(() => {
            setMiniSidenav(dispatch, !miniSidenav);
            setTimeout(() => {
                isTogglingSidenavRef.current = false;
            }, 150);
        });
    }, [dispatch, miniSidenav]);




    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true);


            } catch (error) {
                console.error('Failed loading static mocks or transforming data:', error);
                setError('Failed to load static mock data. Check competitive_analysis/data/allMocks.json');
            } finally {
                setLoading(false);
            }
        };

        fetchAllData();
    }, [location.search, propSubcategoryToken]);

    const mockData = [
        {
            id: "10001",
            name: "7-Eleven",
            logo: Banner1,
            channel: "Convenience",
            coverage: "National",
            parent: "7-Eleven Inc.",
            route: "DSD",
            doors: "4,321",
            color: "#10001"
        },
        {
            id: "10002",
            name: "Walmart",
            logo: Banner_2,
            channel: "Mass, Grocery",
            coverage: "National",
            parent: "Walmart Inc.",
            route: "Direct, DSD",
            doors: "4,321",
            color: "#10002"
        },
        {
            id: "10003",
            name: "Sam’s Club",
            logo: Banner_3,
            channel: "Club",
            coverage: "National",
            parent: "Walmart Inc.",
            route: "DSD",
            doors: "4,321 ",
            color: "#10003"
        },
        {
            id: "10004",
            name: "HEB",
            logo: Banner2,
            channel: "Grocery",
            coverage: "Regional",
            parent: "HEB Grocery Company",
            route: "Direct",
            doors: "4,321 ",
            color: "#10004"
        },
        {
            id: "10005",
            name: "Kroger",
            logo: Banner5,
            channel: "Grocery",
            coverage: "National",
            parent: "Kroger Co.",
            route: "Direct",
            doors: "4,321 ",
            color: "#10005"
        },
        {
            id: "10006",
            name: "Safeway",
            logo: Banner6,
            channel: "Grocery",
            coverage: "National",
            parent: "Albertsons Companies",
            route: "DSD",
            doors: "4,321 ",
            color: "#10006"
        },
        {
            id: "10007",
            name: "CVS",
            logo: Banner7,
            channel: "Pharmacy",
            coverage: "National",
            parent: "CVS Health",
            route: "Direct",
            doors: "4,321 ",
            color: "#10007"
        },
        {
            id: "10008",
            name: "Walgreens",
            logo: Banner8,
            channel: "Pharmacy",
            coverage: "National",
            parent: "Walgreens Boots Alliance",
            route: "Direct",
            doors: "4,321 ",
            color: "#10008"
        },
        {
            id: "10009",
            name: "The Vitamin Shoppe",
            logo: Banner9,
            channel: "Specialty",
            coverage: "National",
            parent: "Franchise Group",
            route: "Direct",
            doors: "4,321 ",
            color: "#10009"
        },
        {
            id: "10010",
            name: "GNC Live Well",
            logo: Banner10,
            channel: "Specialty",
            coverage: "National",
            parent: "GNC Holdings",
            route: "Direct",
            doors: "4,321 ",
            color: "#10010"
        },
        {
            id: "10011",
            name: "CTown",
            logo: Banner11,
            channel: "Grocery",
            coverage: "Regional",
            parent: "Alpha 1 Marketing",
            route: "DSD",
            doors: "4,321 ",
            color: "#10011"
        },
        {
            id: "10012",
            name: "Super Fresh",
            logo: Banner12,
            channel: "Grocery",
            coverage: "Regional",
            parent: "Key Food Stores",
            route: "DSD",
            doors: "4,321 ",
            color: "#10012"
        },
        {
            id: "10013",
            name: "Costco Wholesale",
            logo: Banner13,
            channel: "Club",
            coverage: "National",
            parent: "Costco Wholesale Corp.",
            route: "Direct",
            doors: "4,321 ",
            color: "#10013"
        },
        {
            id: "10014",
            name: "Target",
            logo: Banner14,
            channel: "Mass, Grocery",
            coverage: "National",
            parent: "Target Corporation",
            route: "Direct",
            doors: "4,321 ",
            color: "#10014"
        },
        {
            id: "10015",
            name: "BJ’s",
            logo: Banner15,
            channel: "Club",
            coverage: "Regional",
            parent: "BJ’s Wholesale Club",
            route: "Direct",
            doors: "4,321 ",
            color: "#10015"
        }
    ];


    const RetailsDetails = () => {
        naviagte("/network/retailers/details");

    }


    const [openFilters, setOpenFilters] = useState(false);
    const handleToggleFilters = () => {
        setOpenFilters((prev) => !prev);
    };

    // Filter state
    const [activeFilter, setActiveFilter] = useState('All');
    const [filterLoading, setFilterLoading] = useState(false);

    // Define filter presets for each quick filter
    const getFilterPreset = useCallback((filterName) => {
        const allCompanies = ["Nutrabolt", "Bloom"];
        const allCategories = ["Functional Beverage", "Active Nutrition"];
        const allBrands = ["C4", "Cellucor", "XTEND", "Bloom"];
        const allSubBrands = ["C4", "C4 Performance", "C4 Smart Energy", "C4 Ultimate", "XTEND", "Bloom Sparkling Energy", "Bloom Pop"];
        const allRoutes = ["Ecommerce", "Direct", "DSD"];
        const allChannels = ["Ecommerce", "Convenience Chain", "Convenience Independent", "Drug", "Food", "Multi Outlet", "Mass"];

        switch (filterName) {
            case 'All':
                return {
                    Company: allCompanies,
                    Category: allCategories,
                    Brand: allBrands,
                    "Sub-Brand": allSubBrands,
                    "Route to Market": allRoutes,
                    Channel: allChannels,
                };
            case 'DSD':
                return {
                    Company: allCompanies,
                    Category: allCategories,
                    Brand: allBrands,
                    "Sub-Brand": allSubBrands,
                    "Route to Market": ["DSD"],
                    Channel: allChannels,
                };
            case 'Direct':
                return {
                    Company: allCompanies,
                    Category: allCategories,
                    Brand: allBrands,
                    "Sub-Brand": allSubBrands,
                    "Route to Market": ["Direct"],
                    Channel: allChannels,
                };
            case 'National':
            case 'Regional':
            case 'KDP Distributed':
                // These might map to specific channels or routes - using all for now
                return {
                    Company: allCompanies,
                    Category: allCategories,
                    Brand: allBrands,
                    "Sub-Brand": allSubBrands,
                    "Route to Market": allRoutes,
                    Channel: allChannels,
                };
            default:
                return null;
        }
    }, []);

    const [filterPresets, setFilterPresets] = useState(() => getFilterPreset('All'));

    // Handle filter click with full-page loader
    const handleFilterClick = (filter) => {
        if (filter === activeFilter || filterLoading) return;

        setFilterLoading(true);
        setLoading(true); // Show full-page loader

        // Simulate loading delay
        setTimeout(() => {
            const preset = getFilterPreset(filter);
            setActiveFilter(filter);

            // Set the preset - this will trigger FilterPanelContainer to apply it
            if (preset) {
                setFilterPresets(preset);
            } else {
                setFilterPresets(null);
            }

            setFilterLoading(false);
            setLoading(false); // Hide full-page loader

            // Open filter panel for "Custom" filter
            if (filter === 'Custom') {
                setOpenFilters(true);
            }
        }, 800);
    };

    // Handle filter changes from FilterPanelContainer
    const handleFiltersChange = useCallback((newFilters) => {
        // Don't check for preset match if we're already in Custom mode
        // FilterPanelContainer's isApplyingPresetRef prevents callback when applying presets
        if (activeFilter === 'Custom') return;

        // Check if the current filters match any preset
        const presetNames = ['All', 'DSD', 'Direct', 'National', 'Regional', 'KDP Distributed'];
        let matchedPreset = null;

        for (const presetName of presetNames) {
            const preset = getFilterPreset(presetName);
            if (preset) {
                const isMatching = Object.keys(preset).every(key => {
                    const presetValues = [...(preset[key] || [])].sort();
                    const currentValues = [...(newFilters[key] || [])].sort();
                    return presetValues.length === currentValues.length &&
                        presetValues.every((val, idx) => val === currentValues[idx]);
                });

                if (isMatching) {
                    matchedPreset = presetName;
                    break;
                }
            }
        }

        // If filters don't match any preset, switch to Custom
        if (!matchedPreset && activeFilter !== 'Custom') {
            setActiveFilter('Custom');
            setFilterPresets(null);
        }
    }, [activeFilter, getFilterPreset]);
    const [hover, setHover] = React.useState(false);
    return (


        <Box sx={{
            ml: 0,
            transition: "margin-left 0.25s ease",
            "& .MuiBox-root": { backgroundImage: "none" }
        }} style={{
            padding: isMobile ? '8px' : '0px 16px 0px 16px',
            fontFamily: 'inter'
        }}>
            {/* Loading Backdrop */}
            <Backdrop
                open={loading}
                sx={{
                    position: 'fixed',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                }}
            >
                <CircularProgress color="primary" />
            </Backdrop>

            <Box
                sx={{
                    height: {
                        xs: "calc(100dvh - 140px)", // mobile header
                        md: "calc(100vh - 64px)",  // desktop header
                    },
                    overflowY: "auto",
                    // px: isMobile ? 1 : 2,
                    pb: "100px",
                    /* smooth scrolling */
                    scrollBehavior: "smooth",
                    WebkitOverflowScrolling: "touch", // iOS momentum

                    /* hide scrollbar */
                    scrollbarWidth: "none",          // Firefox
                    msOverflowStyle: "none",         // IE / Edge
                    "&::-webkit-scrollbar": {
                        display: "none",               // Chrome / Safari
                    },
                }}
            >
                {/* Section Title: KPI's */}
                <Typography sx={{ fontSize: '16px', mb: 1, mt: 3 }}>
                    <span style={{ color: '#1672B980', fontWeight: 200, fontSize: "16px" }}>Retailers / </span> <span style={{ fontSize: "16px", fontWeight: 200 }}>93 Results</span>
                </Typography>
                <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mb: 0 }} />
                <Box sx={{ mt: 6 }}>
                    {/* Retailer Cards */}
                    <Grid container spacing={2} sx={{ px: 1 }}>
                        {mockData.map((item) => (
                            <Grid key={item.id} item xs={12} sm={6} md={4} sx={{ paddingBottom: "30px" }}>
                                <Card
                                    sx={{
                                        background: "#fff",
                                        boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.15)",
                                        position: "relative",
                                        paddingTop: "30px",
                                        minHeight: "auto",
                                        overflow: "visible",
                                        cursor: "pointer",
                                        transition: "transform 0.2s",
                                        // transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                        willChange: "transform",
                                        backfaceVisibility: "hidden",

                                        "&:hover": {
                                            transform: "translateY(-4px)",   // no scale
                                            // boxShadow: "0px 12px 24px rgba(0,0,0,0.25)",
                                        },
                                        borderRadius: "4px !important",
                                        border: "none"
                                    }}
                                    onClick={RetailsDetails}
                                >
                                    {/* HEADER */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "-24px",
                                            left: "12px",
                                            right: "12px",
                                            height: "186px",
                                            // background: "#0d6efd",
                                            boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.15)",
                                            borderRadius: "6px !important",
                                            display: "flex",
                                            alignItems: "center",
                                            // px: 2,
                                            background: "#fff",
                                            color: "#3ca32fff",
                                            fontWeight: 600,
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            // px: 2,
                                            fontWeight: 600,
                                            fontSize: "16px",
                                            zIndex: 10,
                                            border: "none",
                                            overflow: "hidden"
                                        }}
                                    >
                                        <img src={item.logo} alt={item.name} style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover" //  fills entire box
                                        }} />
                                    </Box>
                                    <Box sx={{ marginTop: "144px" }}>
                                        <p style={{ fontWeight: "300", textAlign: "center", fontSize: "16px", color: "rgba(17,17,17,0.5)" }}>{item.color}</p>
                                        <p style={{ fontWeight: "500", fontSize: "16px", paddingLeft: "16px", lineHeight: 1 }}>{item.name}</p>
                                        <Box
                                            sx={{
                                                width: "100%",
                                                mt: "17px",
                                                position: "relative",
                                                overflow: "visible",
                                                minHeight: "20px",
                                            }}
                                        >
                                            {/* LEFT CONNECTOR */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "-7px",
                                                    left: "4px",
                                                    width: "10px",
                                                    height: "26px",
                                                    borderLeft: "0.75px solid #17527b",
                                                    borderTop: "0.75px solid  #a1b8c9",
                                                    borderTopLeftRadius: "6px",
                                                    zIndex: 1,
                                                }}
                                            />

                                            {/* RIGHT CONNECTOR */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "-7px",
                                                    right: "4px",
                                                    width: "10px",
                                                    height: "26px",
                                                    borderRight: "0.75px solid #17527b",
                                                    borderTop: "0.75px solid #a1b8c9",
                                                    borderTopRightRadius: "6px",
                                                    zIndex: 1,
                                                }}
                                            />

                                            {/* Chips container */}
                                            <Box sx={{ display: "flex", justifyContent: "space-between", zIndex: 2 }}>
                                                <Chip
                                                    label="CHANNEL"
                                                    size="small"
                                                    sx={{
                                                        background: "#004271",
                                                        color: "#fff",
                                                        fontSize: "10px",
                                                        whiteSpace: "nowrap",
                                                        height: "14px",
                                                        borderTopLeftRadius: "0px",
                                                        borderTopRightRadius: "4px",
                                                        borderBottomRightRadius: "10px",
                                                        borderBottomLeftRadius: "0px",
                                                        paddingLeft: '2px',
                                                        paddingRight: '2px',
                                                        marginLeft: "4px",
                                                        fontWeight: 300
                                                    }}
                                                />
                                                <Chip
                                                    label="COVERAGE"
                                                    size="small"
                                                    sx={{
                                                        background: "#005ba4",
                                                        color: "#fff",
                                                        fontSize: "10px",
                                                        height: "14px",
                                                        whiteSpace: "nowrap",
                                                        borderTopLeftRadius: "4px",
                                                        borderTopRightRadius: "0px",
                                                        borderBottomRightRadius: "0px",
                                                        borderBottomLeftRadius: "10px",
                                                        paddingLeft: '2px',
                                                        paddingRight: '2px',
                                                        marginRight: "4px",
                                                        fontWeight: 300
                                                    }}
                                                />
                                            </Box>
                                        </Box>

                                        {/* TOP VALUES */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                marginTop: "4px",
                                                width: "100%"
                                            }}
                                        >
                                            <Typography sx={{ fontSize: "16px", marginLeft: "8px", fontWeight: 200, lineHeight: 1 }}>
                                                {item.channel}
                                            </Typography>
                                            <Typography sx={{ fontSize: "16px", fontWeight: 200, lineHeight: 1, marginRight: "8px" }}>
                                                {item.coverage}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                width: "100%",
                                                mt: "19px",
                                                position: "relative",
                                                overflow: "visible",
                                                minHeight: "20px",
                                            }}
                                        >
                                            {/* LEFT CONNECTOR */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "-7px",
                                                    left: "4px",
                                                    width: "10px",
                                                    height: "26px",
                                                    borderLeft: "0.75px solid #17527b",
                                                    borderTop: "0.75px solid  #a1b8c9",
                                                    borderTopLeftRadius: "6px",
                                                    zIndex: 1,
                                                }}
                                            />

                                            {/* RIGHT CONNECTOR */}
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: "-7px",
                                                    right: "4px",
                                                    width: "10px",
                                                    height: "26px",
                                                    borderRight: "0.75px solid #17527b",
                                                    borderTop: "0.75px solid #a1b8c9",
                                                    borderTopRightRadius: "6px",
                                                    zIndex: 1,
                                                }}
                                            />

                                            {/* Chips container */}
                                            <Box sx={{ display: "flex", justifyContent: "space-between", zIndex: 2 }}>
                                                <Chip
                                                    label="PARENT COMPANY"
                                                    size="small"
                                                    sx={{
                                                        background: "#005ba4",
                                                        color: "#fff",
                                                        fontSize: "10px",
                                                        whiteSpace: "nowrap",
                                                        height: "14px",
                                                        borderTopLeftRadius: "0px",
                                                        borderTopRightRadius: "4px",
                                                        borderBottomRightRadius: "10px",
                                                        borderBottomLeftRadius: "0px",
                                                        paddingLeft: '2px',
                                                        paddingRight: '2px',
                                                        marginLeft: "4px",
                                                        fontWeight: 300
                                                    }}
                                                />
                                                <Chip
                                                    label="ROUTE TO MARKET"
                                                    size="small"
                                                    sx={{
                                                        background: "#004271",
                                                        color: "#fff",
                                                        fontSize: "10px",
                                                        whiteSpace: "nowrap",
                                                        height: "14px",
                                                        borderTopLeftRadius: "4px",
                                                        borderTopRightRadius: "0px",
                                                        borderBottomRightRadius: "0px",
                                                        borderBottomLeftRadius: "10px",
                                                        paddingLeft: '2px',
                                                        paddingRight: '2px',
                                                        marginRight: "4px",
                                                        fontWeight: 300
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                        {/* TOP VALUES */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                marginTop: "4px",
                                                width: "100%"
                                            }}
                                        >
                                            <Typography sx={{ fontSize: "16px", marginLeft: "8px", fontWeight: 200, lineHeight: 1 }}>
                                                {item.parent}
                                            </Typography>
                                            <Typography sx={{ fontSize: "16px", fontWeight: 200, marginRight: "8px", lineHeight: 1 }}>
                                                {item.route}
                                            </Typography>
                                        </Box>
                                        <Box
                                            sx={{
                                                position: "relative",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                fontSize: "14px",
                                                padding: "12px 14px",
                                                marginTop: "22px",
                                                justifyContent: "flex-end",

                                                /* remove normal border */
                                                borderTop: "none",

                                                /* custom top border with side gaps */
                                                "&::before": {
                                                    content: '""',
                                                    position: "absolute",
                                                    top: 0,
                                                    left: "14px",
                                                    right: "14px",
                                                    height: "1px",
                                                    backgroundColor: "rgba(17, 17, 17, 0.1)",
                                                },
                                            }}
                                        >
                                            <LocationOnIcon sx={{ fontSize: "11px", color: "#C7C7C7", fontWeight: 300 }} />
                                            <span style={{ color: "#C7C7C7", fontSize: "11px", fontWeight: 300 }}>{item.doors} Views</span>
                                        </Box>

                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Box>
        </Box>

    );
};

export default Retails;